import { BigNumber } from '@ethersproject/bignumber'
import { useEffect, useState } from 'react'
import { useEthers } from '../../hooks'
import { ChainTokenRewards, LpRewardPairs } from './model'
import { ChainId, CHAIN_ID_NAMES } from '../../constants'

export function useApiTokenRewards() {
  const { account, chainId = ChainId.Mainnet } = useEthers()
  const [tokenRewards, setTokenRewards] = useState<ChainTokenRewards>({})

  useEffect(() => {
    let cancelled = false
    async function updateTokenRewards() {
      if (account) {
        try {
          const res = await fetch(
            `https://${chainId === ChainId.Kovan ? 'kovan-api' : 'api'}.integral.link/api/v3/token-rewards?network=${
              CHAIN_ID_NAMES[chainId]
            }&address=${account}`
          )
          const json = await res.json()
          if (!cancelled) {
            if (json && json.success) {
              const { lpRewards, tradeRewards } = json.data
              setTokenRewards((tokenRewards) => ({
                ...tokenRewards,
                [chainId]: {
                  lpRewards: lpRewards.reduce((memo: LpRewardPairs, pair: { [key: string]: any }) => {
                    memo[pair.address] = {
                      pairName: pair.name,
                      pairAddress: pair.address,
                      lpTokens: BigNumber.from(pair.lpTokens),
                      tokenRewards: {
                        total: BigNumber.from(pair.tokenRewards.total),
                      },
                    }
                    return memo
                  }, {}),
                  tradeRewards: {
                    ...(tradeRewards.daily
                      ? {
                          daily: {
                            start: new Date(tradeRewards.daily.start),
                            end: new Date(tradeRewards.daily.end),
                            volume: BigNumber.from(tradeRewards.daily.volume),
                            limit: BigNumber.from(tradeRewards.daily.limit),
                          },
                        }
                      : {}),
                    tokenRewards: {
                      participation: BigNumber.from(tradeRewards.tokenRewards.participation),
                      volume: BigNumber.from(tradeRewards.tokenRewards.volume),
                      total: BigNumber.from(tradeRewards.tokenRewards.total),
                    },
                  },
                },
              }))
            }
          }
        } catch (err) {
          console.error(err)
          if (!cancelled) {
            setTokenRewards((tokenRewards) => ({ ...tokenRewards, [chainId]: undefined }))
          }
        }
      }
    }
    updateTokenRewards()
    const interval = setInterval(updateTokenRewards, 3 * 60 * 1000)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [chainId, account])

  return chainId && tokenRewards[chainId]
}
